import {Auditoria} from "../../bibliotecaPjus/models/comum.models";
import {IFormulario, IModel} from "../../bibliotecaPjus/models/contrato.models";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {LIMITES_CARACTERES} from "../helper/limites-caracteres.const";

export class AceitarProposta extends Auditoria implements IModel, IFormulario {

  propostaId: string;
  profissao: string;
  telefoneCredor: string;
  emailCredor: string;
  observacaoCredor: string;

  form: FormGroup;

  constructor(other?: any) {
    super(other);
    if (other) {
      this.propostaId = other.propostaId;
      this.profissao = other.profissao;
      this.telefoneCredor = other.telefoneCredor;
      this.emailCredor = other.emailCredor;
      this.observacaoCredor = other.observacaoCredor;
    }
  }

  get asForm(): FormGroup {
    if (this.form == null) {
      this.form = new FormGroup({
        propostaId: new FormControl(this.propostaId),
        profissao: new FormControl(this.profissao, [Validators.required]),
        telefoneCredor: new FormControl(this.telefoneCredor, [Validators.required]),
        emailCredor: new FormControl(this.emailCredor, [Validators.required, Validators.email]),
        observacaoCredor: new FormControl(this.observacaoCredor, [Validators.maxLength(LIMITES_CARACTERES.OBSERVACAO)]),
      });
    }
    return this.form;
  }

  updateForm(other): void {
    this.form.patchValue(other);
  }
}

